import State, { LocationSlice } from 'types/State';
import { AutolistUser } from 'types/User';
import { SrpFilterValue, SrpFilterName, SrpFilterValues } from 'types/srpFilters';

import { Lead } from 'types/Apis/Lead';
import * as srpFilters from './srpFilters';
import * as leads from './leads';

export function getUser(state: State): Partial<AutolistUser> {
  return state.user;
}

export function getIsSignedIn(state: State): boolean {
  return !!state.session.isSignedIn;
}

export function getSrpFiltersInitialized(state: State): boolean {
  return srpFilters.getSrpFiltersInitialized(state.srpFilters);
}

export function getSrpFilterValues(state: State): SrpFilterValues {
  return srpFilters.getSrpFilterValues(state.srpFilters);
}

export function getSrpFilterValue<T extends SrpFilterValue>(state: State, name: SrpFilterName): T {
  return srpFilters.getSrpFilterValue<T>(state.srpFilters, name);
}

export function getSrpMobileSidebarOpen(state: State): boolean {
  return srpFilters.getSrpMobileSidebarOpen(state.srpFilters);
}

export function getLeadByVin(state: State, vin: string): Lead | undefined {
  return leads.getLeadByVin(state.leads, vin);
}

export function getGeoLocation(state: State): LocationSlice {
  return state.geolocation;
}

export function getFavoritedVins(state: State): string[] {
  return state.favorites.allVins;
}
